<template>
  <div class="addModel">
    <div class="addfrom">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" labelPosition='left'>
        <el-row>
          <el-col :span="24">
            <el-form-item label="公司名称：" prop="name">
              <el-input v-model="ruleForm.name" maxlength="80"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="公司简称：" prop="path">
              <el-input v-model="ruleForm.path" maxlength="80"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="排序编号：" prop="sortOrder">
              <el-input v-model.number="ruleForm.sortOrder" maxlength="8"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="广电计量送检账号：" prop="gdAccount">
              <el-input v-model="ruleForm.gdAccount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="广电计量送检密码：" prop="gdPassword">
              <el-input v-model="ruleForm.gdPassword"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="单位地址：" prop="address">
              <el-input v-model="ruleForm.address" maxlength="150"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="联系电话：" prop="address">
              <el-input v-model="ruleForm.phone" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="24">
          <el-form-item label="线下交接状态：" prop="openDeliver">
            <el-select v-model="ruleForm.openDeliver" placeholder="请选择线下交接状态">
              <el-option
                v-for="item in openDeliverOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="是否发送短信：" prop="allowSms">
              <el-select v-model="ruleForm.allowSms" placeholder="请选择">
                <el-option
                  v-for="item in [{label:'是',value:1},{label:'否',value:0}]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
        </el-col>
      </el-form>
      <div class='footer'>
        <el-button v-waves class="mybtny" @click="submit">保存</el-button>
        <el-button v-waves class="mybtny" @click="resetForm">重置</el-button>
        <el-button v-waves class="mybtnn" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['editData'],
  data() {
    return {
      ruleForm: {
        name: '',
        path: '',
        sortOrder: '',
        address: '',
        phone:'',
        allowSms:0,
      },
      openDeliverOptions:[{value:true,label:"是"},{value:false,label:"否"}],
      rules: {
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        path: [
          { required: true, message: '请输入公司简称', trigger: 'blur' }
        ],
        sortOrder: [
          { required: true, message: '请输入排序', trigger: 'blur' },
          { type: 'number', message: '排序必须为数字值'}
        ],
      },
    };
  },
  created() {
    if (this.editData) {
      this.ruleForm = this.editData;
    }
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.ruleForm, false);
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
}
</script>

<style lang='less' scoped>
.addModel {
  .addfrom {
    margin: 0 30px;
    .topcontent {
      margin-bottom: 20px;
      .el-row {
        margin-bottom: 0;
        height: 40;
      }
      p {
        padding: 0 10px;
      }
    }
    .el-row {
      margin-bottom: 22px;
      &:last-child {
        // margin-bottom: 0;
      }
      /deep/.el-input__inner {
        height: 33px;
        width: 80%;
      }
      /deep/.el-select {
        width: 160px;
        /deep/.el-input__inner {
          width: 100%;
        }
      }
      .el-col-7,.el-col-8,.el-col-9 {
        height: 32px;
      }
      /deep/.el-form-item {
        margin-bottom: 10px;
      }
      /deep/.el-form-item__label {
        padding: 0;
      }
    }
  }
  /deep/.el-button {
    width: 100px;
  }
  .footer {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/sysmanage/Companymanage/components/editModel.vue